<template>
  <div class="settings-form">
    <div class="form-group">
      <label class="form-label">Background Color</label>
      <div class="form-color-input">
        <input 
          v-model="localStyles['background-color']"
          type="color"
          @input="emitUpdate"
        />
        <input 
          v-model="localStyles['background-color']"
          type="text"
          class="form-input"
          placeholder="#ffffff"
          @input="emitUpdate"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="form-label">Text Color</label>
      <div class="form-color-input">
        <input 
          v-model="localStyles['color']"
          type="color"
          @input="emitUpdate"
        />
        <input 
          v-model="localStyles['color']"
          type="text"
          class="form-input"
          placeholder="#000000"
          @input="emitUpdate"
        />
      </div>
    </div>

    <div class="form-group">
      <label class="form-label">Padding</label>
      <input 
        v-model="localStyles['padding']"
        type="text"
        class="form-input"
        placeholder="10px, 10px 20px, 10px 20px 30px 40px"
        @input="emitUpdate"
      />
    </div>

    <div class="form-group">
      <label class="form-label">Margin</label>
      <input 
        v-model="localStyles['margin']"
        type="text"
        class="form-input"
        placeholder="0, 10px auto, 10px 0 20px 0"
        @input="emitUpdate"
      />
    </div>

    <div class="form-group">
      <label class="form-label">Border</label>
      <input 
        v-model="localStyles['border']"
        type="text"
        class="form-input"
        placeholder="1px solid #ccc"
        @input="emitUpdate"
      />
    </div>

    <div class="form-group">
      <label class="form-label">Border Radius</label>
      <input 
        v-model="localStyles['border-radius']"
        type="text"
        class="form-input"
        placeholder="4px, 50%, 10px 20px"
        @input="emitUpdate"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  styles: {
    type: Object,
    default: () => ({})
  }
});

const emit = defineEmits(['update']);

const localStyles = ref({ ...props.styles });

watch(() => props.styles, (newStyles) => {
  localStyles.value = { ...newStyles };
}, { deep: true });

function emitUpdate() {
  emit('update', localStyles.value);
}
</script>

